<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>Satıcı Başvuruları</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">Satıcı Başvuruları</a></li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <h3 class="tile-title">Satıcı Başvuruları</h3>
            <div class="tile-body">
              <form class="form-horizontal">
                <div class="form-group row">
                  <p style="display: none" id="notice_id">{{ result.id }}</p>
                </div>
                <div class="form-group row">
                  <label class="control-label col-md-3"
                    >ALICI MAİL ADRESİ:</label
                  >
                  <div class="col-md-8">
                    <div>
                      {{ result.email }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="control-label col-md-3"
                    >İçerik Metnini Giriniz:</label
                  >
                  <div class="col-md-8">
                    <ckeditor
                      style="border: solid 1px"
                      @ready="onReady"
                      :editor="editor"
                      v-model="result.content"
                      class="form-control"
                      rows="4"
                    ></ckeditor>
                  </div>
                </div>
                <!-- <div class="form-group row">
                  <label class="control-label col-md-3">Fotoğraf:</label>
                  <div class="col-md-8">
                    <div class="form-group">
                      <input
                        v-model="result.imgUrl"
                        id="link"
                        class="form-control"
                        type="url"
                        placeholder="Proje Linkini Giriniz"
                      />
                    </div>
                  </div>
                </div> -->
              </form>
            </div>
            <div class="tile-footer">
              <div class="row">
                <div class="col-md-8 col-md-offset-3">
                  <button
                    @click="sendContent()"
                    class="btn btn-info"
                    type="button"
                  >
                    <i class="fa fa-check-circle"></i>Cevap Gönder
                  </button>
                  &nbsp;
                  <button
                    @click="sendData()"
                    class="btn btn-primary"
                    type="button"
                  >
                    <i class="fa fa-fw fa-lg fa-check-circle"></i>Onayla
                  </button>
                  &nbsp;
                  <button
                    @click="deleteData()"
                    class="btn btn-danger"
                    type="button"
                  >
                    <i class="fa fa-trash-o"></i>Sil
                  </button>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <div class="tile-body">
              <table class="table table-hover table-bordered" id="sampleTable">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Başlık</th>
                    <th>İçerik</th>
                    <th>Resim</th>
                    <th>Resim Adı</th>
                    <th>Tarih</th>
                    <th>Tarih</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import Modal from "./default/Modal";
import axios from "axios";
import store from "../store";
import DecoupledDocument from "@ckeditor/ckeditor5-build-decoupled-document";
export default {
  data() {
    return {
      editor: DecoupledDocument,
      web_url: this.$store.state.web_url,
      result: {
        id: "",
        header: "",
        content: "",
        link: "",
        imgSrc: "",
        email: "",
      },
      file: "",
      fileWarn: "",
    };
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },

    sendData: function() {
      var url = store.state.base_url + "SuperAdmin/insertAppeal.php?key=123";

      var datas = {
        appeal_id: this.result.id,
        id: localStorage.getItem("id"),
        super_token: localStorage.getItem("token"),
        content: this.result.content,
      };

      axios
        .post(url, JSON.stringify(datas))
        .then(() => {
          location.reload();

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    sendContent: function() {
      var url = store.state.base_url + "SuperAdmin/sendContentAppeal.php?key=123";

      var datas = {
        appeal_id: this.result.id,
        id: localStorage.getItem("id"),
        super_token: localStorage.getItem("token"),
        content: this.result.content,
      };

      axios
        .post(url, JSON.stringify(datas))
        .then(() => {
          location.reload();

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    deleteData: function() {
      var url = store.state.base_url + "SuperAdmin/deleteAppeal.php?key=123";

      var datas = {
        appeal_id: this.result.id,
        id: localStorage.getItem("id"),
        super_token: localStorage.getItem("token"),
        content: this.result.content,
      };

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          echo(response);
          if (response.data == true) {
            location.reload();
          }
          //conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
  },

  mounted() {
    var results = this.result;
    var url = store.state.base_url + "SuperAdmin/getAllAppeal.php?key=123";

    var datas = {
      super_token: localStorage.getItem("token"),
      id: localStorage.getItem("id"),
    };

    return axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        //conso.log(response);
        datas = response.data.data;
        var table = $("#sampleTable").DataTable();

        $.each(datas, function(index, value) {
          table.row
            .add([
              value["id"],
              value["name"] + " " + value["surname"],
              value["adress"],
              value["city"] + "/" + value["town"],
              value["email"],
              value["telephone"],
              value["reg_date"],
            ])
            .draw(false);
        });

        $("#sampleTable tbody").on("click", "tr", function() {
          var data = table.row(this).data();

          results.id = data[0];
          results.email = data[4];
          results.imgSrc = store.state.img_base_url + data[4];
          results.imgUrl = data[4];
        });
      })
      .catch((err) => {
        //conso.log(err.response);
      });
  },

  components: {
    Header,
    Sidebar,
    Modal,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Appends.vue